import type { Color } from "@scrolly/post-types";
import THREE from "../THREE";

export function threeToColor(threeColor: THREE.Color, alpha: number = 1): Color {
    return {
        r: Math.round(threeColor.r * 255),
        g: Math.round(threeColor.g * 255),
        b: Math.round(threeColor.b * 255),
        a: alpha,
    };
}

// Unsere Color ist 0..255 im sRGB-Raum (die Werte aus den Farbwaehlern),
// THREE.Color ist 0..1.
//
// ⚠️ `new THREE.Color(r, g, b)` legt die Werte im ARBEITS-Farbraum ab — und der
// ist seit three r152 LINEAR (ColorManagement ist per Default an). Ein
// Farbwaehler-Wert wurde damit als linearer Wert gedeutet und beim Ausgeben
// nach sRGB aufgehellt: aus (235,235,210) wurde am Bildschirm (246,246,234).
// Bei hellen Materialien plus HDRI lief das direkt ins Ausbrennen (Jans Fund
// "Schachflaeche total ueberstrahlt": 18.860 auf Weiss geclippte Bildpunkte,
// nach dem Fix 0). Jans 1.0 lief auf three r139, wo ColorManagement noch AUS
// war und der Wert unveraendert durchlief — die explizite sRGB-Angabe stellt
// also genau das 1.0-Verhalten wieder her.
export function colorToThree(color: Color): THREE.Color {
    return new THREE.Color().setRGB(
        color.r / 255,
        color.g / 255,
        color.b / 255,
        THREE.SRGBColorSpace
    );
}
